import { render, staticRenderFns } from "./SharedTipsInfoCopy.vue?vue&type=template&id=7ccabbf5&scoped=true&"
import script from "./SharedTipsInfoCopy.vue?vue&type=script&lang=js&"
export * from "./SharedTipsInfoCopy.vue?vue&type=script&lang=js&"
import style0 from "./SharedTipsInfoCopy.vue?vue&type=style&index=0&id=7ccabbf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccabbf5",
  null
  
)

export default component.exports